<template>
  <div class="questions-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>
    <div class="questions-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}">
      <div class="questions-title">{{ $t('message.questionsPage.title') }}</div>
      <div
        v-for="(item, index) in questionsPageData.items"
        :key="index"
        class="question-item-wrapper"
      >
        <div class="question-text-block" @click="questionToggle(index)">
          <div class="question">
            {{ item.title }}
          </div>
          <img :src="require(`../../../../public/custom/images/question-cross-${questionItemsStatus[index] ? 'open' : 'close'}.svg`)" alt="Question image">
        </div>
        <div :class="{'open': questionItemsStatus[index]}" class="answer-text-block">
          <ul :class="{'no-bullets': item.noBullets}">
            <li v-for="(line, lineIndex) in item.lines" :key="lineIndex">
              <template v-for="(part, partIndex) in line">
                <span v-if="part.type === 'text'" :key="`${lineIndex}-${partIndex}-text`">{{ part.value }}</span>
                <b v-else-if="part.type === 'bold'" :key="`${lineIndex}-${partIndex}-bold`">{{ part.value }}</b>
                <span v-else-if="part.type === 'important'" :key="`${lineIndex}-${partIndex}-important`" class="answer-block-important">{{ part.value }}</span>
                <router-link v-else-if="part.type === 'router-link'" :key="`${lineIndex}-${partIndex}-router`" class="answer-block-link" :to="part.to">{{ part.value }}</router-link>
                <a v-else-if="part.type === 'external-link'" :key="`${lineIndex}-${partIndex}-external`" :href="part.href" class="answer-block-link" target="_blank">{{ part.value }}</a>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaticPagesHeader from '../../../components/common/StaticPagesHeader.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Questions',
  components: {
    StaticPagesHeader
  },
  data() {
    return {
      isMobileMenuOpen: false,
      questionItemsStatus: {},
    };
  },
  methods: {
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    questionToggle(item) {
      this.$set(this.questionItemsStatus, item, !this.questionItemsStatus[item]);
    },
  },
  computed: {
    ...mapGetters(['profile']),
    questionsPageData() {
      return this.$i18n.messages[this.$i18n.locale].message.questionsPage;
    },
    isAuthorized() {
      return this.profile?.role;
    },
  },
};
</script>

<style lang="scss" scoped>
  .questions-page-wrapper {
    @include base-page-wrapper;
    @include static-heading-container;
  }

  .questions-container {
    @include base-page-container;

    padding: 70px 50px 140px 50px;
    box-sizing: border-box;
    justify-content: flex-start;
    flex-direction: column;
  }

  .questions-title {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 40px;
    line-height: 125%;
    color: #181A1B;
  }

  .question-item-wrapper {
    border-top: 1px solid #CDCDCD;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .question-text-block {
    padding: 31px 0 30px 0;
    box-sizing: border-box;
    font-weight: 600;
    font-size: 22px;
    line-height: 130%;
    color: #121212;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .answer-text-block {
    width: 100%;
    padding-right: 20%;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #333333;
    transition: max-height 0.25s ease, opacity 0.25s ease, padding-bottom 0.25s ease;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    cursor: default;

    ul {
      margin-top: 0;
      margin-bottom: 0;

      li {
        margin-bottom: 10px;
      }
    }

    b {
      color: #121212;
      font-weight: 700;
    }
  }

  .open {
    padding-bottom: 30px;
    max-height: 3000px;
    opacity: 1;
    box-sizing: border-box;
  }

  .answer-block-link {
    color: #2F80ED;
    text-decoration: none;
  }

  .answer-block-important {
    color: #EB5757;
  }

  .no-bullets {
    padding-left: 0;
    li {
      list-style-type: none;
    }
  }

  @media screen and (max-width: 1560px) {
    .answer-text-block {
      font-size: calc(8px + 10 * (100vw / 1920));
    }

    .answer-text-block {
      padding-right: 10%;
    }
  }

  @media screen and (max-width: 940px) {
    .questions-container {
      padding: 50px 0 140px 0;
    }

    .questions-title {
      font-size: 30px;
    }

    .question-text-block {
      font-size: 18px;
      padding: 24px 0 23px 0;
    }

    .answer-text-block {
      font-size: 13px;
    }
  }

  @media screen and (max-width: 610px) {
    .open {
      padding-bottom: 0;
    }
  }
</style>